import { useMutation } from '@apollo/react-hooks';
import { kmsClient, UPDATE_FACEBOOK_ADS_STATE_MUTATION } from 'api';
import {
  UpdateFacebookAdsStatusMutation,
  UpdateFacebookAdsStatusMutation_updateFacebookAdsState_facebookAds,
  UpdateFacebookAdsStatusMutationVariables
} from './__generated__/UpdateFacebookAdsStatusMutation';

type MutationProps = {
  onStart?: (variables: UpdateFacebookAdsStatusMutationVariables) => void;
  onCompleted?: (facebookAds: UpdateFacebookAdsStatusMutation_updateFacebookAdsState_facebookAds[]) => void;
  onError?: (
    facebookAds: UpdateFacebookAdsStatusMutation_updateFacebookAdsState_facebookAds[],
    errors: string[]
  ) => void;
};

export const useUpdateFacebookAdsState = ({ onStart, onCompleted, onError }: MutationProps) => {
  const [updateFacebookAd] = useMutation<UpdateFacebookAdsStatusMutation, UpdateFacebookAdsStatusMutationVariables>(
    UPDATE_FACEBOOK_ADS_STATE_MUTATION,
    {
      client: kmsClient,
      onCompleted: (data) => {
        if (data.updateFacebookAdsState?.errors?.length) {
          if (onError) onError(data.updateFacebookAdsState.facebookAds || [], data.updateFacebookAdsState.errors);
        } else {
          if (onCompleted && data.updateFacebookAdsState?.facebookAds)
            onCompleted(data.updateFacebookAdsState.facebookAds);
        }
      },
      onError: (error) => onError && onError([], [error.message])
    }
  );
  return (variables: UpdateFacebookAdsStatusMutationVariables) => {
    if (onStart) onStart(variables);
    updateFacebookAd({ variables });
  };
};
